import { render, staticRenderFns } from "./fee-hosting.vue?vue&type=template&id=ee5301a8&scoped=true"
import script from "./fee-hosting.vue?vue&type=script&lang=js"
export * from "./fee-hosting.vue?vue&type=script&lang=js"
import style0 from "./fee-hosting.vue?vue&type=style&index=0&id=ee5301a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5301a8",
  null
  
)

export default component.exports